import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { useContext } from 'react';
import { intrinsicComponent } from '../../utils/functions';
import DrawerContext from './drawer.context';
import Styled from './drawer.styles';
var DrawerHeader = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(DrawerContext),
    isCollapsed = _useContext.isCollapsed;
  return /*#__PURE__*/React.createElement(Styled.Header, _extends({}, rest, {
    isCollapsed: isCollapsed,
    ref: ref
  }), children);
});
export default DrawerHeader;